import {createAction, props} from '@ngrx/store';
import {ContactOutputInterface, ContactPagedResponse, ShortConactInterface} from '@app/marketplace/checkout/_models/contact.model';
import {ResponseBaseModel} from '@app/marketplace/core/models/response.model';
import {AddressVerificationResponse, CheckoutInterface} from '@app/marketplace/checkout/_models/checkout.model';
export const LOADING_ADDRESS = '[Checkout-Address] Loading address';
export const GET_ADDRESS = '[Checkout-Address] Get address';
export const UPDATING_ADDRESS = '[Checkout-Address] Updating address';
export const UPDATED_ADDRESS = '[Checkout-Address] Updated address';
export const CANCEL_ADDRESS_REQUEST = '[Checkout-Address] cancel request';
export const ERROR_ADDRESS_REQUEST = '[Checkout-Address] Checkout request error';
export const CLEAR_DATA = '[Checkout-Address] Clear data';
export const LoadingAddress = createAction(
  LOADING_ADDRESS);
export const GetAddress = createAction(
  GET_ADDRESS,
  props<{ data: AddressVerificationResponse}>()
);
export const UpdatingAddress = createAction(
  UPDATING_ADDRESS,
  props<{ payload: any }>()
);
export const UpdatedAddress = createAction(
  UPDATED_ADDRESS,
  props<{ data: ResponseBaseModel }>()
);
export const CleaningData = createAction(
  CLEAR_DATA);
export const CancelAddressRequest
  = createAction(
  CANCEL_ADDRESS_REQUEST
);
